module.exports = __webpack_public_path__ + "img/bespoke123_04.6b5f8efa.jpg";